var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEditionIcon = function SvgEditionIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 21480",
    fill: "none",
    d: "M0 0h14v14H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.624 8.369v3.421l-2.97 1.711V10.08Zm-6.4 3.421 2.97 1.711V10.08l-2.97-1.711Zm-6.855 0 2.97 1.711V10.08L.369 8.369ZM6.995.5l-2.9 1.671 2.9 1.671 2.9-1.671Zm-3.2 13 2.97-1.711V8.368l-2.97 1.711Zm-.229-7.237L.596 7.974l2.97 1.711 2.97-1.711Zm3.656 1.316 2.9-1.671V2.566l-2.9 1.671Zm-.457-3.342-2.9-1.671v3.342l2.9 1.671V4.237Zm3.656 2.027-2.97 1.711 2.97 1.711 2.97-1.711Z",
    fill: "#606060",
    fillRule: "evenodd"
  })));
};
export default SvgEditionIcon;